/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCursorText = createReactComponent("cursor-text", "IconCursorText", [
  ["path", { d: "M10 12h4", key: "svg-0" }],
  ["path", { d: "M9 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3", key: "svg-1" }],
  ["path", { d: "M15 4a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3", key: "svg-2" }]
]);

export { IconCursorText as default };
//# sourceMappingURL=IconCursorText.js.map
